// ── WhatsApp mask ─────────────────────────────────────────────────────────────
const whatsappFields = document.querySelectorAll('.form-contato [name="whatsapp"]');

whatsappFields.forEach((field) => {
  field.addEventListener('input', (event) => {
    const digits = event.target.value.replace(/\D/g, '').slice(0, 11);

    if (digits.length > 6) {
      event.target.value = `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    } else if (digits.length > 2) {
      event.target.value = `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    } else if (digits.length) {
      event.target.value = `(${digits}`;
    } else {
      event.target.value = '';
    }
  });
});

// ── Form validation + AJAX submit ─────────────────────────────────────────────
const form = document.querySelector('.form-contato__form');

if (form) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearErrors(form);

    if (!window.rbContatoAjax?.url) {
      showFeedback(form, 'Erro de configuração do formulário. Tente recarregar a página.', 'error');
      return;
    }

    const errors = validateForm(form);
    if (errors.length > 0) {
      errors.forEach(({ field, message }) => showFieldError(field, message));
      errors[0].field.focus();
      return;
    }

    const btn = form.querySelector('.form-contato__btn');
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Enviando...';

    const data = new FormData(form);
    data.set('action', 'rb_contact_form_submit');

    try {
      const response = await fetch(window.rbContatoAjax.url, {
        method: 'POST',
        body: data,
      });

      if (!response.ok) throw new Error('network');

      const json = await response.json();

      if (json.success) {
        showFeedback(form, json.data.message, 'success');
        form.reset();
      } else {
        const msg = json.data?.message || 'Ocorreu um erro. Tente novamente.';
        showFeedback(form, msg, 'error');
      }
    } catch (err) {
      console.error('Contact form error:', err);
      showFeedback(form, 'Ocorreu um erro de conexão. Tente novamente.', 'error');
    } finally {
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function validateForm(form) {
  const errors = [];
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const rules = [
    { name: 'nome',            type: 'text',   message: 'Por favor, preencha este campo.' },
    { name: 'sobrenome',       type: 'text',   message: 'Por favor, preencha este campo.' },
    { name: 'email',           type: 'email',  message: 'Informe um endereço de email válido.' },
    { name: 'whatsapp',        type: 'phone',  message: 'Informe um número de WhatsApp válido.' },
    { name: 'tipo_investidor', type: 'select', message: 'Por favor, selecione uma opção.' },
    { name: 'assunto',         type: 'select', message: 'Por favor, selecione uma opção.' },
    { name: 'produto_servico', type: 'select', message: 'Por favor, selecione uma opção.' },
  ];

  rules.forEach(({ name, type, message }) => {
    const field = form.querySelector(`[name="${name}"]`);
    if (!field) return;

    let invalid = false;
    if (type === 'text')   invalid = field.value.trim() === '';
    if (type === 'email')  invalid = !emailRe.test(field.value.trim());
    if (type === 'phone')  invalid = field.value.replace(/\D/g, '').length < 10;
    if (type === 'select') invalid = field.value === '';

    if (invalid) errors.push({ field, message });
  });

  return errors;
}

function showFieldError(field, message) {
  const container = field.closest('.form-contato__field');
  if (!container) return;
  container.classList.add('form-contato__field--error');
  const span = document.createElement('span');
  span.className = 'form-contato__error-msg';
  span.textContent = message;
  container.appendChild(span);
}

function clearErrors(form) {
  form.querySelectorAll('.form-contato__field--error').forEach((el) => {
    el.classList.remove('form-contato__field--error');
  });
  form.querySelectorAll('.form-contato__error-msg').forEach((el) => el.remove());

  const feedback = form.querySelector('.form-contato__feedback');
  if (feedback) {
    feedback.className = 'form-contato__feedback';
    feedback.textContent = '';
  }
}

function showFeedback(form, message, type) {
  const feedback = form.querySelector('.form-contato__feedback');
  if (!feedback) return;
  feedback.className = `form-contato__feedback form-contato__feedback--${type}`;
  feedback.textContent = message;
  feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
